export default __webpack_public_path__ + "81601887c5f6cf469e222b443dfcf92a.png";